import { RoutePath } from 'src/data/Routes';
import type { MenuNode } from 'src/model/MenuNode';

export type AlertingSection = MenuNode & { readonly path: string; };

/** No `component` here — it would break the page's code-split. */
export const ALERTING_SECTIONS = [
  { key: 'alerting-alerts', path: '/alerts', title: 'Alerts', isLeaf: true },
  { key: 'alerting-hw', path: '/hw', title: 'HW Events', isLeaf: true },
  { key: 'alerting-email', path: '/email', title: 'Email', isLeaf: true },
  { key: 'alerting-options', path: '/options', title: 'Options', isLeaf: true, adminOnly: true },
  { key: 'alerting-service-now', path: '/service-now', title: 'Service Now', isLeaf: true, adminOnly: true },
  { key: 'alerting-integrations', path: '/integrations', title: 'Integrations', isLeaf: true },
  { key: 'alerting-zabbix', path: '/zabbix', title: 'Zabbix', isLeaf: true },
] as const satisfies readonly AlertingSection[];

export type AlertingSectionPath = typeof ALERTING_SECTIONS[number]['path'];

/** No admin check — usable only before `isAdmin` is known; prefer {@link getDefaultAlertingSectionPath}. */
export const ALERTING_SECTION_DEFAULT = RoutePath.ALERTING + ALERTING_SECTIONS[0].path;

export function getAllowedAlertingSections(sections: readonly AlertingSection[], isAdmin: boolean): AlertingSection[] {
  return sections.filter(section => !section.adminOnly || isAdmin);
}

export function resolveAlertingSection(
  sections: readonly AlertingSection[], slug: string | undefined, isAdmin: boolean,
): AlertingSection | null {
  if (!slug) return null;
  return getAllowedAlertingSections(sections, isAdmin).find(section => section.path === '/' + slug) ?? null;
}

/** First section this user may see, so an `adminOnly` first section cannot trap a non-admin in a redirect loop. */
export function getDefaultAlertingSectionPath(isAdmin: boolean): string {
  return RoutePath.ALERTING + getAllowedAlertingSections(ALERTING_SECTIONS, isAdmin)[0].path;
}
